<div
  class="d-flex align-items-center justify-content-between"
  [class.project-overview-header]="projectOverview()"
  style="min-height: 40px;"
>
  <div class="left d-flex align-items-center gap-2">
  </div>
  <app-global-search #globalSearch></app-global-search>
  <div class="middle flex-grow-1 d-flex justify-content-center">

    <p-button
      size="small"
      class="header-search-button"
      severity="secondary"
      outlined="true"
      (onClick)="this.openSearch()"
      i18n-pTooltip="@@global-search-tooltip"
      pTooltip="Globale Suche (⌘K)"
    >
      <div class="d-flex header-search-btn gap-2">
        <i class="ri-search-line"></i>
        @if (projectOverview()) {
          <span class="d-none d-md-inline text-muted" i18n="@@project-global-search-label">Suche nach Projekten, Bots, Dateien …</span>
        } @else {
          <span class="d-none d-md-inline text-muted" i18n="@@global-search-button">Suche</span>
        }
        <kbd class="d-none d-lg-inline ms-auto">⌘K</kbd>
      </div>
    </p-button>
  </div>

  <div class="right text-end d-flex align-items-center gap-2">
    <div class="d-flex align-items-center gap-1">
      <button
        type="button"
        class="btn btn-sm col-hover"
        aria-label="Deutsch"
        [ngClass]="{'active': this.langService.getLanguage() === 'de'}"
        (click)="this.langService.setLanguage('de')"
      >
        <span
          class="language-flag"
          style="background-image: url('assets/de.svg');"
        ></span>
      </button>
      <button
        type="button"
        class="btn btn-sm col-hover"
        aria-label="English"
        [ngClass]="{'active': this.langService.getLanguage() === 'en'}"
        (click)="this.langService.setLanguage('en')"
      >
        <span
          class="language-flag"
          style="background-image: url('assets/en.svg');"
        ></span>
      </button>
    </div>
    <reflact-user-menu
      [authenticated]="true"
      [userName]="this.loginService.loggedInUser?.name ?? ''"
      [userEmail]="this.loginService.loggedInUser?.email ?? ''"
      [mandants]="this.mandantContext.mandants()"
      [mandantId]="this.mandantContext.activeOrgShort()"
      [contextLabel]="this.mandantContext.activeOrgShort() ? '' : this.allMandantsLabel"
      [additionalContexts]="this.additionalContexts()"
      [additionalUserItems]="this.userMenuItems"
      [portalUrl]="this.portalUrl"
      (mandantChange)="this.mandantContext.select($event)"
      (logoutRequested)="this.loginService.logout(true)"
    />
  </div>

</div>
